<script lang="ts">
	import { storeCookieSelection } from '$lib/js/stores'
	import { onMount } from 'svelte'
	import { t } from 'svelte-i18n-lingui'
	import Switch from '@smui/switch'
	import { getContextScope } from '$lib/js/helpers/i18n'

	export let uClass = 'closed'

	const scope = getContextScope()

	let configure = false
	let analytics = false
	let ads = false

	let consent = {
		ad_storage: 'denied',
		analytics_storage: 'denied',
		ad_user_data: 'denied',
		ad_personalization: 'denied',
	}

	function closeNotice(value: string) {
		if (value == 'all') {
			consent = {
				ad_storage: 'granted',
				analytics_storage: 'granted',
				ad_user_data: 'granted',
				ad_personalization: 'granted',
			}
		}
		if (value == 'configured') {
			consent = {
				ad_storage: ads ? 'granted' : 'denied',
				analytics_storage: analytics ? 'granted' : 'denied',
				ad_user_data: ads ? 'granted' : 'denied',
				ad_personalization: ads ? 'granted' : 'denied',
			}
		}
		if (value == 'none') {
			consent = {
				ad_storage: 'denied',
				analytics_storage: 'denied',
				ad_user_data: 'denied',
				ad_personalization: 'denied',
			}
		}
		$storeCookieSelection = consent
		gtag('consent', 'update', $storeCookieSelection)
	}

	onMount(() => {
		if (!$storeCookieSelection || $storeCookieSelection === 'not-selected') {
			uClass = 'opened'
		} else {
			uClass = 'closed'
		}
	})
</script>


<div class="cookie-notice {uClass}">
	<div class="cookie-notice__inner">
		<div class="cookie-notice__title">
			<h2 class="head-5">{$t`Cookies & privacy`}</h2>
		</div>

		{#if configure}
			<div class="cookie-configuration">
				<p
					class="cookie-configuration__msg">{$t`If you require more information about how bixoto and third parties manage your data when accepting cookies, you can consult our`}
					<a href="/{scope}/politica-de-cookies">{$t`cookies policy`}</a>
					{$t`or`}
					<a href="https://business.safety.google/intl/{scope}/privacy/" rel="external"
						 target="_blank">{$t`Google's data processing policy`}</a>.</p>

				<div class="cookie-configuration__block">
					<div class="cookie-configuration__block__title">
						<label>{$t`Analysis and performance cookies`}</label>
						<span class="switch-holder">
              <Switch bind:checked={analytics} />
            </span>
					</div>

					<p
						class="cookies-description">{$t`A collection of cookies to gather information about website usage statistics without individually identifying visitors.`}</p>
				</div>

				<div class="cookie-configuration__block">
					<div class="cookie-configuration__block__title">
						<label>{$t`Advertisement cookies`}</label>
						<span class="switch-holder">
              <Switch bind:checked={ads} />
            </span>
					</div>

					<p
						class="cookies-description">{$t`Advertising cookies are used to track and monitor visitor actions on the website to provide a personalized user experience.`}</p>
				</div>

				<div class="cookie-configuration__block">
					<div class="cookie-configuration__block__title">
						<label>{$t`Essential cookies`}</label>
						<span class="switch-holder">
              <Switch checked={true} disabled />
            </span>
					</div>

					<p
						class="cookies-description">{$t`These cookies are essential for the correct functionality of the website, therefore they can not be deactivated.`}</p>
				</div>

				<div class="cookie-configuration__btns">
					<button on:click={() => closeNotice('configured')} class="validate u-btn">{$t`Validate`}</button>
				</div>
			</div>
		{:else}
			<p>{$t`We use our own and third-party cookies for the correct functioning of the website and for the purpose of compiling statistical information and showing you personalized advertising through the analysis of your browsing.`}</p>
			<br>
			<p>{$t`You can configure the cookies according to your preferences by clicking on the "Configure" button. This allows you to select which types of cookies to enable or disable. You can also accept or reject them all.`}</p>
			<br>
			<p>{$t`Find more information in our`} <a href="/{scope}/politica-de-privacidad">{$t`privacy policy`}</a> {$t`and`}
				<a href="/{scope}/politica-de-cookies">{$t`cookies policy`}</a>.</p>

			<div class="cookie-notice__btns">
				<button on:click={() => {configure = true}} class="configure u-btn u-btn--grey-l">{$t`Configure`}</button>
				<button on:click={() => closeNotice('none')} class="reject u-btn u-btn--grey-l">{$t`Reject`}</button>
				<button on:click={() => closeNotice('all')} class="accept u-btn">{$t`Accept`}</button>
			</div>
		{/if}
	</div>
</div>


<style lang="scss">
  .cookie-configuration {
    &__msg {
      margin-bottom: 10px;
    }

    &__block {
      margin-bottom: 10px;

      &__title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        label {
          font-size: 16px;
          font-weight: 700;
        }
      }
    }

    &__btns {
      display: flex;
      justify-content: flex-end;
      margin-top: 15px;

      @media (max-width: 768px) {
        margin-top: 25px;
        flex-direction: column;
      }

      .validate {
        font-size: 16px;

        @media (min-width: 769px) {
          padding: 8px 50px;
        }
      }
    }
  }

  .cookie-notice {
    position: fixed;
    bottom: 40px;
    padding: 20px;
    visibility: hidden;
    opacity: 0;

    @media (min-width: 769px) {
      left: calc(50% - 340px);
    }
    @media (max-width: 769px) {
      width: 100%;
      padding: 0px;
      bottom: 0px;
    }

    &.opened {
      visibility: visible;
      opacity: 1;
      z-index: 9999;
    }

    &__inner {
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
      padding: 20px;
      max-width: 600px;
      background: white;
      border-radius: 4px;

      @media (min-width: 769px) {
        padding: 30px;
      }

      h2 {
        display: inline-block;
        border-bottom: 2px solid var(--main);
      }
    }

    &__title {
      display: flex;
      justify-content: center;
      margin-bottom: 8px;
    }

    &__btns {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      text-align: center;
      margin-top: 20px;

      @media (max-width: 768px) {
        flex-direction: column-reverse;
      }

      button {
        font-size: 16px;

        @media (min-width: 769px) {
          padding: 8px 50px;
        }

        &.configure {
          background: none;
          border: none;
          color: var(--main);

          @media (min-width: 769px) {
            padding: 8px 20px;
          }
        }

        &.reject {
          background: none;

          &:hover {
            background: var(--grey--b);
            border-color: var(--grey--b);
          }
        }
      }
    }
  }
</style>
